import type React from 'react';
import type { State } from '../../common/types.tsx';

const setSidebarContent =
	(id: string, content: React.ReactElement | null) =>
	({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
		const state = getState();
		setState({
			...state,
			id,
			content,
		});
	};

const closeSidebar =
	() =>
	({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
		const state = getState();

		setState({
			...state,
			id: null,
			content: null,
		});
	};

export const actions = {
	setSidebarContent,
	closeSidebar,
} as const;
